import React, { useState } from "react";

//form
import FormHeader from "../../../form/ModamilyAppFormHeader";
import ButtonGroup from "../../../form/ModamilyAppButtonGroup";

// cosntants
import Options from "../../../../constants/formOptions";
import ModamilyAppCheckButton from "../../../form/ModamilyAppCheckButton";
import { capitalize } from "lodash";
import ModamilyAppRadioButton from "../../../form/ModamilyAppRadioButton";
import { useEffect } from "react";

const buttonOptions = Options.lookingFors;

const coParentOptions = [
  "Dating (Romantic)",
  "Platonic (Friends)",
  "Open To Both",
];

const LookingFor = ({
  gender,
  selectedGendersIndexes,
  selectedLookingForIndexes,
  searchPreferences,
  handleUpdate,
}) => {
  const [selected, setSelected] = useState([...selectedLookingForIndexes]);
  const [coParentOptions, setCoParentOptions] = useState([
    {
      id: 0,
      text: "Dating (Romantic)",
      value: "co-parent-romantic",
      selected: selectedLookingForIndexes.includes("co-parent-romantic"),
    },
    {
      id: 1,
      text: "Platonic (Friends)",
      value: "co-parent-friends",
      selected: selectedLookingForIndexes.includes("co-parent-friends"),
    },
    {
      id: 2,
      text: "Open To Both",
      value: "co-parent",
      selected: selectedLookingForIndexes.includes("co-parent"),
    },
  ]);

  const [showAllGenders, setShowAllGenders] = useState(false);

  const getGenderOptions = () => {
    if (showAllGenders) {
      return Options.genders;
    }
    return Options.lookingGender;
  };

  useEffect(() => {
    searchPreferences.lookingFor = getLookingForValues();
    handleUpdate(searchPreferences);
  }, [selected, coParentOptions]);

  const getLookingForValues = () => {
    const opts = selected.map((s) => {
      if (s.startsWith("co-parent")) {
        return coParentOptions.find((a) => a.selected === true).value;
      }
      return s;
    });

    return opts;
  };

  const checkOptions = (option) => {
    const sel = selected.map((s) =>
      s.indexOf("co-parent") > -1 ? "co-parent" : s
    );
    const newSelection = [];
    let coParentOpts = coParentOptions;
    const opt = option;
    if (sel.indexOf(opt) < 0) {
      newSelection.push(opt);
      newSelection.push(...sel);
      if (opt === "co-parent") {
        coParentOpts = coParentOpts.map((o) => {
          o.selected = o.value === "co-parent";
          return o;
        });
      }
    } else {
      newSelection.push(...sel.filter((e) => !e.startsWith(opt)));
      if (opt.indexOf("co-parent") > -1) {
        coParentOpts = coParentOpts.map((o) => {
          o.selected = false;
          return o;
        });
      }
    }
    setSelected([...newSelection]);
    setCoParentOptions([...coParentOpts]);
  };

  const checkCoparentOption = (opt) => {
    const coParentOpts = coParentOptions.map((c) => {
      c.selected = c.value === opt;
      return c;
    });
    setCoParentOptions(coParentOpts);

    // handleUpdate?
    // console.info(getLookingForValues(), "checkCoparent");
  };

  const getCoparentOptsView = () => {
    return coParentOptions.map((c, idx) => {
      return (
        <ModamilyAppRadioButton
          text={c.text}
          key={`coparent_key_${idx}`}
          active={c.selected}
          onClick={(isActive) => {
            checkCoparentOption(c.value);
          }}
        />
      );
    });
  };

  let hasCoParentOption = false;
  coParentOptions.forEach((s) => {
    if (s.selected) {
      hasCoParentOption = true;
    }
  });
  const opts = Options.lookingFors;

  const genderOptions = getGenderOptions();
  let selectedGenderIndex = -1;
  if (searchPreferences.gender && searchPreferences.gender.length > 0) {
    selectedGenderIndex = genderOptions.indexOf(
      searchPreferences.gender[0]?.toLowerCase()
    );
  }

  return (
    <div className="searchPrefForm">
      <div className="searchPrefLookingForFormContainer">
        <FormHeader text="I'm Looking For" />
        <p className="purpleText boldWeight">SELECT ALL THAT APPLY</p>
        <ButtonGroup
          selected={selectedGenderIndex}
          type="radio"
          data={genderOptions}
          onButtonClick={(value, index) => {
            try {
              if (index > -1) {
                searchPreferences.gender = [value.toLowerCase()];
                handleUpdate(searchPreferences);
              } else {
                searchPreferences.gender = [];
                handleUpdate(searchPreferences);
              }
            } catch (e) {
              console.log("error trying to select the option", e);
            }
          }}
        />
        <button 
          className="moreOptionsButton"
          onClick={() => setShowAllGenders(!showAllGenders)}
        >
          {showAllGenders ? 'Show Basic Options' : 'More Options'}
        </button>
        <FormHeader className="redText" text="&" />
        {opts.map((o, idx) => {
          let coParentOptsView = null;
          let sel = selected.includes(o);
          if (o === "co-parent" && hasCoParentOption) {
            sel = true;
            coParentOptsView = getCoparentOptsView();
          }

          return (
            // <ModamilyAppRadioButton
            //   text={dataPoint}
            //   key={index}
            //   active={selected == index}
            //   onClick={(isActive) => {
            //     this.onButtonClick(dataPoint, index, isActive);
            //   }}
            // />
            <>
              <ModamilyAppCheckButton
                text={capitalize(o)}
                key={idx}
                active={sel}
                onClick={(isActive) => {
                  console.info(o, idx, isActive);
                  checkOptions(o);
                }}
                // manualSelection={this.props.manualSelection}
              />
              {coParentOptsView}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default LookingFor;
